import { FILE_SIZE_ERROR,
        FILE_FORMAT_ERROR,
        FILE_FORMATS_ALLOWED,
        FILE_LIMIT_ERROR,
        FILE_COUNT_ERROR,
        FILE_SIZE_LIMIT } from './../../shared/constants.util';
import { DocumentUploadService } from './../../services/document-upload.service';
import { Component, OnInit, Input, OnChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-document-upload',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./document-upload.component.css']
})
export class DocumentUploadComponent implements OnInit, OnChanges {

  inputDetails: FormGroup;

  @ViewChild('blcAttachments') blcAttachments: any;
  @ViewChild('taxAttachments') taxAttachment: any;
  @ViewChild('creditAttachments') creditAttachment: any;
  @ViewChild('additionalAttachments') additionalAttachments: any;

  @Input() customerType: string;
  inputNumber: string;
  isValid: any;
  docType: string;
  blcDocLabel: string;
  blcFileErrorMessage: string;
  docError = false;
  blcDoc: any | null;
  blcDocB64: any;
  blcDocObject: object = {};
  errorMessage: string;
  taxMultiFileLabels: Array<string> = [];
  taxMultiFiles: Array<any> = [];
  creditMultiFileLabels: Array<string> = [];
  creditMultiFiles: Array<any> = [];
  additionalMultiFileLabels: Array<string> = [];
  additionalMultiFiles: Array<any> = [];
  multiFilesError: string;
  showError = false;
  taxMultiFilesObjects: Array<any> = [];
  creditMultiFilesObjects: Array<any> = [];
  additionalMultiFilesObjects: Array<any> = [];
  mySQLOrgId: number;
  fileUploadSuccess: boolean;
  submitClicked = false;
  noFiles = false;
  noMatch = false;
  msaErrors = false;

  public static renameFile(file, applicationId, prefix) {
    const resultFile = file;
    let resultFileType = resultFile.type.split('/')[1];
    const doc = 'msword';
    const docx = 'vnd.openxmlformats-officedocument.wordprocessingml.document';
    const xls = 'vnd.ms-excel';
    const xlsx = 'vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  
    if(resultFileType === doc) {
      resultFileType = 'doc';
    } else if (resultFileType === docx) {
      resultFileType = 'docx';
    } else if (resultFileType === xls) {
      resultFileType = 'xls';
    } else if (resultFileType === xlsx) {
      resultFileType = 'xlsx';
    }
  
    resultFile.customName = `${applicationId}_${prefix}.${resultFileType}`;
  
    return resultFile;
  }

  constructor(
    private documentUploadService: DocumentUploadService,
    private router: Router
  ) {
    this.mySQLOrgId = 82;
  }



  ngOnInit() {
    this.initializeInputDetails();

    this.customerType === 'newcustomer'
    ? this.inputNumber = 'Application ID'
    : this.inputNumber = 'Customer Number';
  }

  ngOnChanges() {
    // const value = changes.customerType.currentValue;
    // if (this.inputDetails) {
    //   this.inputDetails.reset();
    //   const idControl = this.inputDetails.get('applicationID');
    //   if (value === 'newcustomer') {
    //     this.inputNumber = 'Application ID';
    //     idControl.setValidators([Validators.required, Validators.pattern('^[0-9]{1,6}$')]);
    //     idControl.updateValueAndValidity();
    //   } else {
    //     this.inputNumber = 'Customer Number';
    //     idControl.setValidators([Validators.required, Validators.pattern('^[0-9]{1,6}$')]);
    //     idControl.updateValueAndValidity();
    //   }
    // }
    if (this.inputDetails) {
      this.inputDetails.reset();
      const error = document.getElementById('customerInfo').classList.contains('clr-error');
      error ? document.getElementById('customerInfo').classList.remove('clr-error') : '';
      this.enableInputs();
  }

    this.customerType === 'newcustomer'
    ? this.inputNumber = 'Application ID'
    : this.inputNumber = 'Customer Number';

    this.isValid = false;
    this.blcFileErrorMessage = '';
    this.docError = false;
    this.noFiles = false;
    this.noMatch = false;
    this.msaErrors = false;
    this.blcDoc = undefined;
    this.blcDocLabel = '';
    this.taxMultiFileLabels = [];
    this.taxMultiFiles = [];
    this.creditMultiFileLabels = [];
    this.creditMultiFiles = [];
    this.additionalMultiFileLabels = [];
    this.additionalMultiFiles = [];
  }

  initializeInputDetails() {
    this.inputDetails = new FormGroup({
      applicationID: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{1,7}$')]),
      zipCode: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{5}')])
    });
  }

  search() {
    if (this.customerType === 'newcustomer') {
      this.documentUploadService.searchValue(this.inputDetails.value).subscribe(res => {
      this.isValid = res;
      this.checkRecord(res);
    });
    } else {
      this.documentUploadService.searchCustomerNumber(this.inputDetails.value).subscribe(res => {
        if (res.hasOwnProperty('error')) {
          this.msaError();
        } else {
          this.isValid = res;
          this.checkRecord(res);
        }
      });
    }
  }

  checkRecord(exist) {
    if (!exist) {
      this.noMatch = true;
      document.getElementById('customerInfo').classList.add('clr-error');
    } else {
      this.msaErrors = false;
      this.noMatch = false;
      const error = document.getElementById('customerInfo').classList.contains('clr-error');
      error ? document.getElementById('customerInfo').classList.remove('clr-error') : '';
      this.disableInputs();
    }
  }

  msaError() {
    document.getElementById('customerInfo').classList.add('clr-error');
    this.msaErrors = true;
  }

  disableInputs() {
    const inputs = document.querySelectorAll('input[type=text]');
    Array.from(inputs).forEach(field => {
      field.setAttribute('disabled', '');
    });
  }

  enableInputs() {
    const inputs = document.querySelectorAll('input[type=text]');
    Array.from(inputs).forEach(field => {
      field.removeAttribute('disabled');
    });
  }

 onMultiFileChange(event, docType: string) {
   this.noFiles = false;
   const files: Array<any> = event.target.files;
   console.log(files)
   this.docError = false;

   const fileTypeLabel = {
     tax: this.taxMultiFileLabels,
     additional: this.additionalMultiFileLabels,
     credit: this.creditMultiFileLabels
   };

   const fileTypeFiles = {
      tax: this.taxMultiFiles,
      additional: this.additionalMultiFiles,
      credit: this.creditMultiFiles
   };

   if (this.fileSanityCheck(files, true)) {
    Array.from(files).forEach(file => {
      if (fileTypeLabel[docType].length < 4) {
        fileTypeFiles[docType].push(file);
        fileTypeLabel[docType].push(file.name);
      } else {
        this.docError = true;
        this.multiFilesError = FILE_COUNT_ERROR;
      }
    });

    this.removeFileList(docType);
    } else {
      if (files.length > 4) {
        this.multiFilesError = FILE_COUNT_ERROR;
        this.docError = true;
      } else {
      Array.from(files).forEach(file => {
        if (!FILE_FORMATS_ALLOWED.includes(file.type)) { 
        this.multiFilesError = FILE_FORMAT_ERROR;
        this.docError = true;
        return;
        } else if (file.size > FILE_SIZE_LIMIT) {
        this.multiFilesError = FILE_SIZE_ERROR;
        this.docError = true;
        }
        });
    }
  }
 }

removeFileList(docType) {
    switch (docType) {
      case 'tax':
        this.taxAttachment.nativeElement.value = '';
        break;
      case 'credit':
        this.creditAttachment.nativeElement.value = '';
        break;
      case 'additional':
        this.additionalAttachments.nativeElement.value = '';
    }
 }

onSingleFileChange(event) {
  const file = event.target.files;
  this.noFiles = false;

  if (file.length > 1) {
    alert('filer limit error');
    this.blcFileErrorMessage = FILE_LIMIT_ERROR;
    return;
  }

  if (file) {
    if (file[0]) {
      this.blcDoc = file[0];
      if (file[0].type) {
        if (!FILE_FORMATS_ALLOWED.includes(file[0].type)) {
        this.blcFileErrorMessage = FILE_FORMAT_ERROR;
        return;
      }
    }
      if (file[0].size) {
        if (file[0].size > FILE_SIZE_LIMIT) {
        this.blcFileErrorMessage = FILE_SIZE_ERROR;
        return;
      }
    }
      if (file[0].name) {
      this.blcDocLabel = file[0].name.toString();
    }
  }
} else {
  return;
}


  this.blcFileErrorMessage = '';
  this.docError = false;
  const b64Reader: FileReader = new FileReader();
  b64Reader.readAsDataURL(this.blcDoc);
  b64Reader.onloadend = (e) => {
    this.blcDocB64 = b64Reader.result;
  };
 }

fileSanityCheck(files, allowMultiple: boolean): boolean {
  let result = false;

  // Check No. of Files
  if ((allowMultiple && files.length > 4) || (!allowMultiple && files.length > 1)) {
    return false;
  }

  // Check File(s) Format
  for (const file of files) {
    result = FILE_FORMATS_ALLOWED.includes(file.type);
    if (!result) {
      return result;
    }
  }

  // Check File(s) Size
  for (const file of files) {
    result = file.size < FILE_SIZE_LIMIT;
    if (!result) {
      return result;
    }
  }
  return result;
}


uploadTax(id, arr) {
    const docType = 'Tax';
    this.taxMultiFiles.forEach((taxFile, index) => {
    this.taxMultiFiles[index] = DocumentUploadComponent.renameFile(taxFile, id, `Tax_${index}`);
    this.taxMultiFilesObjects[index] = {};
    if (this.customerType === 'newcustomer') {
       arr.push(this.documentUploadService.uploadDocsStaged(this.taxMultiFiles[index], this.constructFileUploadObj(this.taxMultiFilesObjects[index], id, docType, taxFile)))
    } else {
       arr.push(this.documentUploadService.uploadDocsLive(this.taxMultiFiles[index], this.constructFileUploadObjLive(this.taxMultiFilesObjects[index], id, docType, taxFile)))
  }
});
}

submitDocuments(e) {
  this.submitClicked = true;

  if (this.customerType === 'newcustomer') {

  if (!this.blcDoc && this.taxMultiFiles.length === 0) {
    this.noFiles = true;
  } else {
  const uploadObservable = [];
  const applicationId = this.inputDetails.value.applicationID;

  if (this.blcDoc) {
    const docType = 'BLC';
    this.blcDoc = DocumentUploadComponent.renameFile(this.blcDoc, applicationId, 'BLC');

    uploadObservable.push(this.documentUploadService.uploadDocsStaged(this.blcDoc, this.constructFileUploadObj(this.blcDocObject, applicationId, docType, this.blcDoc)))
}

  if (this.taxMultiFiles.length > 0) {
      this.uploadTax(applicationId, uploadObservable);
  }

  forkJoin(uploadObservable).subscribe(vals => {
    if (!vals) {
      this.fileUploadSuccess = false;
    } else {
      const payload = {
        applicationId: applicationId,
        orgId: this.mySQLOrgId
      };

      this.documentUploadService.addToTransferQueueStaged(payload).subscribe(res => console.log(res));
      this.fileUploadSuccess = true;
      e.target.disabled = true;
      setTimeout(() => {
        this.router.navigate(['success']);
      }, 2000);
    }
  });
  }
} else {
  if (!this.blcDoc && this.taxMultiFiles.length === 0 && this.creditMultiFiles.length === 0 && this.additionalMultiFiles.length === 0) {
    this.noFiles = true;
  } else {
    const customerNumber = this.inputDetails.value.applicationID;
    const uploadObservable = [];

    if (this.blcDoc) {
        const docType = 'BLC';
        this.blcDoc = DocumentUploadComponent.renameFile(this.blcDoc, customerNumber, 'BLC');

        uploadObservable.push(this.documentUploadService.uploadDocsLive(this.blcDoc, this.constructFileUploadObjLive(this.blcDocObject, customerNumber, docType, this.blcDoc)))
    }


    if (this.taxMultiFiles.length > 0) {
        this.uploadTax(customerNumber, uploadObservable);
      }

    if (this.creditMultiFiles.length > 0) {
        const docType = 'FIN';
        this.creditMultiFiles.forEach((creditFile, index) => {
        this.creditMultiFiles[index] = DocumentUploadComponent.renameFile(creditFile, customerNumber, `FIN_${index}`);
        this.creditMultiFilesObjects[index] = {};
        uploadObservable.push(this.documentUploadService.uploadDocsLive(this.creditMultiFiles[index], this.constructFileUploadObjLive(this.creditMultiFilesObjects[index], customerNumber, docType, creditFile)))
      }
    );
  }

    if (this.additionalMultiFiles.length > 0) {
        const docType = 'Other';
        this.additionalMultiFiles.forEach((additionalFile, index) => {
        this.additionalMultiFiles[index] = DocumentUploadComponent.renameFile(additionalFile, customerNumber, `Other_${index}`);
        this.additionalMultiFilesObjects[index] = {};
        uploadObservable.push(this.documentUploadService.uploadDocsLive(this.additionalMultiFiles[index], this.constructFileUploadObjLive(this.additionalMultiFilesObjects[index], customerNumber, docType, additionalFile)))
      }
    );
  }

    forkJoin(uploadObservable).subscribe(vals => {
      if (!vals) {
        this.fileUploadSuccess = false;
      } else {
        const payload = {
          customerNumber: customerNumber,
          orgId: this.mySQLOrgId
        };

        this.documentUploadService.addToTransferQueueLive(payload).subscribe(res => console.log(res));
        this.fileUploadSuccess = true;
        e.target.disabled = true;
        setTimeout(() => {
          this.router.navigate(['success']);
        }, 2000);
      }
    });
  }
}
}

handleError(errMessage?) {
  this.errorMessage = errMessage;
  this.showError = true;
  console.log(`Error Submitting the form: ${errMessage}`);
  const top = document.getElementById('errorMessage');
  this.scroll(top);
}

scroll(el: HTMLElement) {
  el.scrollIntoView({behavior: 'smooth'});
}

constructFileUploadObj(body, applicationId, prefix, file) {
  const result = body;

  result.DOC_NAME = file.customName;
  result.MYSQL_ORG_ID = this.mySQLOrgId;
  result.DOC_TYPE = prefix;
  result.APPLICATION_ID = applicationId;

  return JSON.stringify(result);
}

constructFileUploadObjLive(body, customerNumber, prefix, file) {
  const result = body;

  result.DOC_NAME = file.customName;
  result.MYSQL_ORG_ID = this.mySQLOrgId;
  result.DOC_TYPE = prefix;
  result.ACCOUNT_NUMBER = customerNumber;

  return JSON.stringify(result);
}

removeFile(type, index?) {
      if (type === 'blc') {
        this.blcDoc = null;
        this.blcDocLabel = '';
        this.blcAttachments.nativeElement.value = '';
      } else {
      const fileLabels = {
        tax: this.taxMultiFileLabels,
        credit: this.creditMultiFileLabels,
        additional: this.additionalMultiFileLabels
      };

      const files = {
        tax: this.taxMultiFiles,
        credit: this.creditMultiFiles,
        additional: this.additionalMultiFiles
      };

      fileLabels[type].splice(index, 1);
      files[type].splice(index, 1);
    }
  }
}
